import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import FilterChip from "@/shared/components/filter/FilterChip";

export interface FilterChipItem {
  id: string;
  label: string;
  onRemove: () => void;
}

interface Props {
  title: string;
  chips: FilterChipItem[];
  clearAllLabel: string;
  onClearAll: () => void;
}

function FilterChipList({ title, chips, clearAllLabel, onClearAll }: Props) {
  if (chips.length === 0) {
    return null;
  }

  const clearAllButton = (display: { base: string; md: string }) => (
    <Text
      as={"button"}
      display={display}
      flexShrink={0}
      whiteSpace={"nowrap"}
      textStyle={"body-sm-medium"}
      color={"#8F8F8C"}
      cursor={"pointer"}
      onClick={onClearAll}
      _hover={{ color: "#444440" }}
    >
      {clearAllLabel}
    </Text>
  );

  // 좁은 폭에서는 칩이 쌓일수록 아래로 늘어지므로 한 줄 가로 스크롤로 두고,
  // 자리를 차지하는 제목 대신 `전체 해제`를 왼쪽에 고정한다(스크롤해도 따라 밀리지 않는다).
  // md 이상은 제목 — 칩 — 전체 해제 순서로 여러 줄에 감싼다.
  return (
    <Flex alignItems={"center"} gap={"8px"}>
      {clearAllButton({ base: "inline-block", md: "none" })}
      <Flex
        flex={1}
        minWidth={0}
        alignItems={"center"}
        gap={"8px"}
        flexWrap={{ base: "nowrap", md: "wrap" }}
        overflowX={{ base: "auto", md: "visible" }}
        sx={{
          "::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
        }}
      >
        <Text
          display={{ base: "none", md: "block" }}
          textStyle={"body-sm-medium"}
          color={"#8F8F8C"}
        >
          {title}
        </Text>
        {chips.map((chip) => (
          // 가로 스크롤에서 칩이 찌그러지거나 라벨이 줄바꿈되지 않도록 줄어들지 않게 감싼다.
          <Flex key={chip.id} flexShrink={0}>
            <FilterChip label={chip.label} onRemove={chip.onRemove} />
          </Flex>
        ))}
        {clearAllButton({ base: "none", md: "inline-block" })}
      </Flex>
    </Flex>
  );
}

export default FilterChipList;
